import { render, staticRenderFns } from "./EditSandBox.vue?vue&type=template&id=a1afd084&scoped=true"
import script from "./EditSandBox.vue?vue&type=script&lang=js"
export * from "./EditSandBox.vue?vue&type=script&lang=js"
import style0 from "./EditSandBox.vue?vue&type=style&index=0&id=a1afd084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1afd084",
  null
  
)

export default component.exports